<template>
  <el-card class="box-card" :body-style="{ padding: '0px' }">
    <slot />
  </el-card>
</template>
